import React from "react";
import { Modal } from "@/components/Modal";
import { ProductImage } from "@/components/ProductImage";
import { Heart } from "lucide-react";

export const ZoneShelf = ({ open, onClose, zone, products, memories, onSelect }) => {
  if (!zone) return null;
  return (
    <Modal open={open} onClose={onClose} testId="zone-shelf" maxWidth="max-w-2xl">
      <div className="p-5 sm:p-7">
        <h2 className="font-signboard text-3xl font-bold text-kirana-brown">{zone.label}</h2>
        <p className="mt-1 text-sm text-kirana-brown/70">
          {products.length} item{products.length !== 1 ? "s" : ""} — click one to discover the memory.
        </p>
        {products.length === 0 ? (
          <p className="mt-6 rounded-md border-2 border-dashed border-kirana-border p-6 text-center text-kirana-brown/60">
            Kaka hasn't stocked this shelf yet. Add items from /admin.
          </p>
        ) : (
          <div className="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-3">
            {products.map((p) => {
              const unlocked = memories.includes(p.id);
              return (
                <button
                  key={p.id}
                  data-testid={`shelf-item-${p.id}`}
                  onClick={() => onSelect(p)}
                  className="group relative flex flex-col overflow-hidden rounded-md border-[3px] border-kirana-brown bg-card text-left transition-transform hover:scale-[1.04] hard-shadow-sm"
                >
                  <div className="relative h-24">
                    <ProductImage product={p} />
                    {unlocked && (
                      <span className="absolute right-1 top-1 flex h-6 w-6 items-center justify-center rounded-full border-2 border-kirana-brown bg-kirana-cream">
                        <Heart className="h-3.5 w-3.5 fill-kirana-red text-kirana-red" />
                      </span>
                    )}
                    {p.nostalgia_score >= 4 && !unlocked && (
                      <span className="absolute left-1 top-1 rounded border border-kirana-brown bg-kirana-gold px-1 text-[9px] font-bold text-kirana-brown">
                        FORGOTTEN
                      </span>
                    )}
                  </div>
                  <div className="p-2">
                    <span className="line-clamp-1 text-xs font-bold text-kirana-brown">{p.name}</span>
                    <span className="text-[10px] text-kirana-brown/60">{p.approximate_price}</span>
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </Modal>
  );
};
